/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-len */

import * as React from 'react';
import EventCard from './card';
import { GET, PUT } from '/client/src/api';

type OrderType = {
  pages: []
};

export const Order = (props: OrderType): React.Element<'div'> => {
  const { pages } = props;
  const [events, setEvents] = React.useState(null);
  const [pageId, setPageId] = React.useState(_.get(pages, '[0].id', null));
  const [isPending, setPending] = React.useState(false);

  React.useEffect(() => {
    fetchEvents();
  }, [pageId]);

  const fetchEvents = async () => {
    setPending(true);
    try {
      const { result } = await GET(`/api/v1/1/merchants/facebookpages/${pageId}/events?skip_count=0&max_result_count=200&show_hide_events=false&show_collaborative_events=true`);
      const _events = _.get(result, 'items', []);

      const isEventPlacementIndexesInited = checkEventPlacementIndexesInited(_events);

      if (isEventPlacementIndexesInited) {
        const sortedEvents = _events.sort((a: any, b: any): any => a.placement_index - b.placement_index);

        setEvents(sortedEvents);
      } else {
        await initEventPlacementIndexes(_events);
        fetchEvents();
      }

      setPending(false);
    } catch (e) {
      setEvents([]);
      setPending(false);
      console.log(e);
    }
  };

  const checkEventPlacementIndexesInited = (_events: any): boolean => {
    const zeroIndexes = [];

    _events.forEach((event: any) => {
      if (event.placement_index === 0) {
        zeroIndexes.push(0);
      }
    });
    // return zeroIndexes.length <= 1;
    return true; // TODO: change
  };

  const initEventPlacementIndexes = async (_events: any) => {
    setPending(true);
    await Promise.all(_events.map(async (event: any, i: number) => {
      try {
        await PUT(`/api/v1/1/merchants/facebookpages/${pageId}/events/${_.toString(event.id)}`, {
          placement_index: i
        });
      } catch (error) {
        console.log(error);
        setPending(false);
      }
    }));
    setPending(false);
  };

  const setEventPlacementIndex = async (event_id: any, placement_index: number) => {
    try {
      setPending(true);

      await PUT(`/api/v1/1/merchants/facebookpages/${pageId}/events/${event_id}`, {
        is_display: true,
        placement_index
      });
      setPending(false);
      fetchEvents();
    } catch (e) {
      console.error(e);
      setPending(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: '800px',
        margin: '0px auto'
      }}
      data-bind="i18nWith:$i18n.app.facebook"
      data-view="views/facebook-app/order"
      data-active-view="true"
    >
      <div className="form-group">
        <label>Facebook Page</label>
        <select
          className="form-control"
          style={{ backgroundColor: '#f3f4f8' }}
          onChange={(e: any): any => {
            setPageId(e.target.value);
          }}
          value={pageId}
        >
          {_.map(pages, (p: {}, i: number): React.Element<'option'> => {
            return (
              <option
                key={`order_page-${i}`}
                value={p.id}
              >
                {p.name}
              </option>
            );
          })}
        </select>
      </div>
      <div className="fb-order-view">
          <div className="row sortable">
            {!!_.size(events) ? _.map(events, (ev: {}, evi: {}): React.Element<'div'> => {
              return (
                <EventCard
                  {...ev}
                  key={`EventCard-${evi}`}
                  index={evi}
                  setEventPlacementIndex={setEventPlacementIndex}
                />
              );
            })
              :
              <div className='no-events'>No events</div>
            }
          </div>
          {isPending && <div className='csspinner' />}
      </div>
    </div>
  );
};
